if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

  onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  // --- Loading state ---
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  try {
    // --- Collect main product variant ---
    const formData = new FormData(this.form);
    const mainVariantId = parseInt(formData.get('id'));

    if (!mainVariantId) throw new Error("Main product variant not found.");

    // --- Collect line item properties for main product ---
    const properties = {};
    this.form.querySelectorAll('[name^="properties["]').forEach(input => {
      properties[input.name.replace(/^properties\[(.*)\]$/, '$1')] = input.value;
    });

    // --- Collect checked addon variants ---
    const checkedAddons = document.querySelectorAll(
      '.product-recommendations-addon input[name="recommendation-item-addons"]:checked'
    );

    // --- Generate unique group ID ---
    const groupId = Math.floor(Math.random() * 1000000000); // random number for grouping

    // --- Prepare items array with group_id ---
    const items = [
      {
        id: mainVariantId,
        quantity: 1,
        properties: {
          ...properties,
          group_id: groupId, // add unique group id to main product
          is_main_product: true
        }
      }
    ];

    checkedAddons.forEach((checkbox) => {
      const variantId = parseInt(checkbox.value);
      if (variantId) {
        items.push({
          id: variantId,
          quantity: 1,
          properties: {
            addon_of: mainVariantId, // optional link reference
            group_id: groupId,       // same group as main
            is_addon: true
          }
        });
      }
    });

    // --- POST to Shopify cart ---
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);
        return response.json();
      })
      .then((cartData) => {
        // Update cart object if exists
        if (this.cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData,
          });

          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(cartData);
          });
        }

        this.error = false;
      })
      .catch((err) => {
        console.error(err);
        this.setErrorMessage(window.cartStrings.error || "Something went wrong.");
        this.error = true;
      })
      .finally(() => {
        // Reset loading state
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
        window.location.href = '/cart';
        CartPerformance.measureFromEvent("add:user-action", evt);
      });

  } catch (error) {
    console.error(error);
    this.setErrorMessage(window.cartStrings.error || "Something went wrong.");
    this.submitButton.classList.remove('loading');
    this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  }
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
